import IonIcon from '@reacticons/ionicons'
import cn from 'classnames'

export interface FilterProps {
  className?: string
  onClickFilter: () => void
}

export const Filter: React.FC<FilterProps> = ({ className = '', onClickFilter, ...props }) => {
  return (
    <div className={cn(className, 'top-16', 'cursor-pointer')} {...props}>
      <div className="flex flex-row relative md:mt-1 w-[100px] h-[40.8px]" onClick={onClickFilter}>
        <div className="flex flex-row items-center relative w-full py-2 border-mist border-solid border rounded-[20px] text-left  bg-white">
          <IonIcon name="filter-outline" className="w-[18px] h-[21px] ml-[16px]"></IonIcon>
          <p className="text-[14px] font-secondary text-darkgray font-[500] ml-[10px]">Filter</p>
        </div>
      </div>
    </div>
  )
}
